import MarketingFormEmbed from './marketing-form-embed'

export default MarketingFormEmbed
